module.exports = __webpack_public_path__ + "img/birthday-logo.0bf6c1e8.png";